import { AsyncButton } from "aic";
import { ReactElement } from "react";
import { ArrowCounterclockwise, PlayCircle, PlusCircle } from "react-bootstrap-icons";

/**
 * Props for the contextual apply, create or master-reset icon.
 */
export interface TlfVariantApplyButtonProps {
  action: "apply" | "create" | "reset";
  disabled: boolean;
  onApply: () => void;
}

/**
 * Renders a labelled icon for the variant command available in the current state.
 *
 * @param props - Apply availability and callback supplied by the sidebar
 * @param props.action - Contextual command represented by the icon
 * @param props.disabled - Whether the current selection cannot be applied
 * @param props.onApply - Runs the apply, naming or reset command supplied by the selector
 * @returns The accessible contextual command icon
 */
export const TlfVariantApplyButton = ({
  action,
  disabled,
  onApply,
}: TlfVariantApplyButtonProps): ReactElement => {
  const labels = { apply: "Apply", create: "Create variant", reset: "Reset to master" };
  const icons = { apply: PlayCircle, create: PlusCircle, reset: ArrowCounterclockwise };
  const Icon = icons[action];
  return (
    <AsyncButton
      id={`tlf-variant-${action}`}
      aria-label={labels[action]}
      title={labels[action]}
      className="p-0 d-flex align-items-center"
      style={{ width: 20, height: 20 }}
      variant="link"
      disabled={disabled}
      onClick={onApply}
    >
      <Icon size={16} />
    </AsyncButton>
  );
};

TlfVariantApplyButton.displayName = "TlfVariantApplyButton";
